import { Injectable, signal } from '@angular/core';

export type GlobalBannerSeverity = 'success' | 'info' | 'warn' | 'error';

export type GlobalBannerState = {
  severity: GlobalBannerSeverity;
  message: string;
  dismissible?: boolean;
  autoHideMs?: number;
};

@Injectable({ providedIn: 'root' })
export class GlobalBannerService {
  private bannerSignal = signal<GlobalBannerState | null>(null);
  public banner = this.bannerSignal.asReadonly();

  private hideTimeoutId: number | null = null;

  public show(state: GlobalBannerState) {
    this.clearHideTimeout();
    const normalized: GlobalBannerState = {
      dismissible: true,
      ...state,
    };
    this.bannerSignal.set(normalized);

    if (normalized.autoHideMs && normalized.autoHideMs > 0) {
      this.hideTimeoutId = window.setTimeout(() => {
        if (this.bannerSignal() === normalized) {
          this.clear();
        }
      }, normalized.autoHideMs);
    }
  }

  public success(message: string, options?: Omit<GlobalBannerState, 'severity' | 'message'>) {
    this.show({ severity: 'success', message, ...options });
  }

  public error(message: string, options?: Omit<GlobalBannerState, 'severity' | 'message'>) {
    this.show({ severity: 'error', message, ...options });
  }

  public clear() {
    this.clearHideTimeout();
    this.bannerSignal.set(null);
  }

  private clearHideTimeout() {
    if (this.hideTimeoutId == null) return;
    window.clearTimeout(this.hideTimeoutId);
    this.hideTimeoutId = null;
  }
}
